import { useState } from "react";
import { useReveal } from "../hooks/useReveal";
import "./Contact.css";

export default function Contact({ data }) {
  const r1 = useReveal(); const r2 = useReveal(); const r3 = useReveal();

  return (
    <div className="ct">

      {/* HERO — light background, stands apart from every other page */}
      <section className="ct-hero">
        <div className="ct-hero-inner wrap">
          <div>
            <span className="ct-hero-tag">{data?.hero?.tag}</span>
            <h1 className="ct-hero-h1">
              {data?.hero?.h1?.map((line, i) => (
                <span key={i} className={line === data?.hero?.italic ? "italic" : ""}>{line}<br /></span>
              ))}
            </h1>
          </div>
          <div>
            <p className="ct-hero-p">{data?.hero?.body}</p>
            {[
              { label: "Headquarters", lines: [data?.info?.address] },
              { label: "Phone",        lines: data?.info?.phones },
              { label: "Email",        lines: [data?.info?.email] },
            ].map(d => (
              <div className="ct-hero-detail" key={d.label}>
                <strong>{d.label}</strong>
                {d.lines?.map((line, i) => {
                  if (line?.startsWith("+")) return <a key={i} href={`tel:${line.replace(/\s/g, "")}`}>{line}</a>;
                  if (line?.includes("@"))  return <a key={i} href={`mailto:${line}`}>{line}</a>;
                  return <span key={i}>{line}</span>;
                })}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DARK SPLIT: form + info */}
      <section className="ct-main" ref={r1}>
        <div className="ct-main-inner wrap">
          <div className="ct-form-panel rv">
            <h2 className="ct-form-h2">{data?.form?.h2}</h2>
            <p className="ct-form-sub">{data?.form?.sub}</p>
            <ContactForm services={data?.form?.services} />
          </div>
          <div className="ct-info-panel rv">
            <h2 className="ct-info-h2">We're Based in Bangalore,<br />Working Across India</h2>
            <div>
              {[
                { label: "Office Address", lines: [data?.info?.address] },
                { label: "Phone Numbers",  lines: data?.info?.phones },
                { label: "Email",          lines: [data?.info?.email] },
                { label: "Business Hours", lines: data?.info?.hours },
              ].map(b => (
                <div className="ct-info-block" key={b.label}>
                  <strong>{b.label}</strong>
                  {b.lines?.map((line, i) => {
                    if (line?.startsWith("+")) return <a key={i} href={`tel:${line.replace(/\s/g, "")}`}>{line}</a>;
                    if (line?.includes("@"))  return <a key={i} href={`mailto:${line}`}>{line}</a>;
                    return <span key={i}>{line}</span>;
                  })}
                </div>
              ))}
            </div>
            <div className="ct-soc">
              <p>Follow Us</p>
              <div className="ct-soc-links">
                {Object.entries(data?.social || {}).map(([k, v]) => (
                  <a key={k} href={v} target="_blank" rel="noreferrer">{k}</a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INFO CARDS */}
      <section className="ct-cards" ref={r2}>
        <div className="ct-cards-inner wrap">
          {[
            { ico: "📍", tag: "Location", val: data?.info?.address },
            { ico: "📞", tag: "Phone",    val: data?.info?.phones?.join(" / ") },
            { ico: "✉️",  tag: "Email",    val: data?.info?.email, href: `mailto:${data?.info?.email}` },
          ].map(c => (
            <div className="ct-card rv" key={c.tag}>
              <div className="ct-card-ico">{c.ico}</div>
              <span className="ct-card-tag">{c.tag}</span>
              <div className="ct-card-v">
                {c.href ? <a href={c.href}>{c.val}</a> : c.val}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* MAP */}
      <section className="ct-map" ref={r3}>
        <iframe
          src={data?.mapEmbed}
          allowFullScreen loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="PR Elite Estate Location"
        />
      </section>

    </div>
  );
}

function ContactForm({ services }) {
  const [form, setForm] = useState({
    firstName: "", lastName: "", email: "", phone: "",
    service: "", budget: "", message: "",
  });
  const [status, setStatus] = useState(null);

  const change = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setStatus("sending");
    try {
      const r = await fetch("/api/contact", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const j = await r.json();
      if (j.success) {
        setStatus("ok");
        setForm({ firstName:"", lastName:"", email:"", phone:"", service:"", budget:"", message:"" });
      } else setStatus("err");
    } catch { setStatus("err"); }
  };

  return (
    <form className="cf" onSubmit={submit} noValidate>
      <div className="cf-row">
        <input name="firstName" placeholder="First Name" value={form.firstName} onChange={change} required />
        <input name="lastName"  placeholder="Last Name"  value={form.lastName}  onChange={change} />
      </div>
      <input name="email"  type="email" placeholder="Email Address" value={form.email}  onChange={change} required />
      <input name="phone"  type="tel"   placeholder="Phone Number"  value={form.phone}  onChange={change} />
      <select name="service" value={form.service} onChange={change}>
        <option value="" disabled>Service of Interest</option>
        {services?.map(s => <option key={s}>{s}</option>)}
      </select>
      <input name="budget" placeholder="Approximate Budget / Deal Size (optional)" value={form.budget} onChange={change} />
      <textarea name="message" placeholder="Tell us about your requirements..." value={form.message} onChange={change} required />
      <button type="submit" className="btn btn-r" disabled={status === "sending"}>
        {status === "sending" ? "Sending…" : "Send Message"}
      </button>
      {status === "ok"  && <div className="cf-msg cf-ok">✓ Message sent! We'll be in touch within 24 hours.</div>}
      {status === "err" && <div className="cf-msg cf-err">Something went wrong. Please email us directly.</div>}
    </form>
  );
}
